import React from 'react';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Alert } from '@whitelabel/component-library';
import messages from './messages';

const XpayPaypalAlert = () => {
  const intl = useIntl();
  const location = useLocation();
  // @ts-ignore ts-migrate(2571) FIXME: Object is of type 'unknown'.
  if (!location.state || !location.state.xpayPaypalMessage) {
    return null;
  }

  // @ts-ignore ts-migrate(2571) FIXME: Object is of type 'unknown'.
  const isPaypalConnectSuccessful = location.state.xpayPaypalMessage === 'success';

  return (
    // @ts-ignore ts-migrate(17004) FIXME: Cannot use JSX unless the '--jsx' flag is provided... Remove this comment to see the full error message
    <Alert color={isPaypalConnectSuccessful ? 'success' : 'danger'}>
      {isPaypalConnectSuccessful
        ? intl.formatMessage(messages.xpayPaypalSuccess)
        : intl.formatMessage(messages.xpayPaypalError)}
    </Alert>
  );
};

export default XpayPaypalAlert;
